import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconSmile = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.3332 10.5004C18.3332 15.1028 14.6022 18.8338 9.99984 18.8338C5.39746 18.8338 1.6665 15.1028 1.6665 10.5004C1.6665 5.89798 5.39746 2.16699 9.99984 2.16699C14.6022 2.16699 18.3332 5.89798 18.3332 10.5004ZM6.84165 13.0474C7.64016 13.9559 8.7914 14.4773 9.99986 14.4773C11.2083 14.4773 12.3591 13.9559 13.1581 13.0474C13.4123 12.7584 13.3839 12.3181 13.0949 12.0643C12.8058 11.8101 12.3655 11.8385 12.1118 12.1275C11.5775 12.7355 10.8078 13.0843 9.99986 13.0843C9.1919 13.0843 8.42225 12.7355 7.88792 12.1275C7.63369 11.839 7.19389 11.8106 6.90483 12.0643C6.61578 12.3186 6.58742 12.7584 6.84165 13.0474ZM7.56699 10.0222C8.1789 10.0222 8.67495 9.52614 8.67495 8.91422C8.67495 8.30231 8.1789 7.80625 7.56699 7.80625C6.95508 7.80625 6.45903 8.30231 6.45903 8.91422C6.45903 9.52614 6.95508 10.0222 7.56699 10.0222ZM13.5413 8.91422C13.5413 9.52613 13.0452 10.0222 12.4333 10.0222C11.8214 10.0222 11.3254 9.52613 11.3254 8.91422C11.3254 8.3023 11.8214 7.80625 12.4333 7.80625C13.0452 7.80625 13.5413 8.3023 13.5413 8.91422Z",
		fill: "#00ABFF"
	})
});
export default SvgIconSmile;
